/**
 * 웹 전용 Sign in with Apple (Wimb과 동일한 방식)
 * name/email 수신을 위해 response_mode=form_post 필수.
 * Apple이 redirect_uri(백엔드)로 POST → 백엔드가 Dreamity 프론트로 302 리다이렉트 (#id_token=...&user=...).
 * 환경 설정(Client ID, 콜백 URL, 서비스명)은 src/config/api.ts 에서만 참조.
 */

import {
  getAppleCallbackUri,
  APPLE_WEB_CLIENT_ID,
  SERVICE_NAME,
} from '@/config/api'

const APPLE_AUTH_URL = 'https://appleid.apple.com/auth/authorize'

export function getAppleWebConfig() {
  const redirectUri = getAppleCallbackUri()
  return { clientId: APPLE_WEB_CLIENT_ID, redirectUri }
}

/**
 * Apple 로그인 페이지로 리다이렉트 (form_post + 백엔드 콜백, 백엔드가 Dreamity로 리다이렉트)
 */
export function redirectToAppleSignIn(guestId?: string): void {
  const { clientId, redirectUri } = getAppleWebConfig()

  if (!redirectUri) {
    console.error('[Apple Web] 콜백 URL을 설정할 수 없습니다. config/api.ts 또는 VITE_APPLE_CALLBACK_URI를 확인하세요.')
    return
  }

  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  const isHttp = typeof window !== 'undefined' && window.location.protocol === 'http:'
  if (isLocalhost || isHttp) {
    console.warn('[Apple Web] HTTPS 환경에서만 정상 동작합니다. redirect_uri:', redirectUri)
  }

  // 백엔드가 리다이렉트 대상 프론트를 알 수 있도록 state에 service 포함 (| 구분)
  const stateParts = [`state_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`, `service=${SERVICE_NAME}`]
  if (guestId) stateParts.push(`guestId=${guestId}`)
  const state = stateParts.join('|')
  const nonce = `nonce_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`

  // name/email scope 사용 시 Apple은 response_mode=form_post만 허용. redirect_uri는 백엔드 URL.
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code id_token',
    response_mode: 'form_post',
    scope: 'name email',
    state,
    nonce,
  })

  const url = `${APPLE_AUTH_URL}?${params.toString()}`
  window.location.href = url
}
